import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const IMPORT_FIELDS = [
  ["date", "Date"], ["start_time", "Start time"], ["locksmith", "Locksmith"], ["officer_name", "Officer name"], ["officer_phone", "Officer phone"],
  ["officer_company", "Officer company"], ["address", "Address *"], ["postcode", "Postcode *"], ["notes", "Address notes"],
];

export const ImportMapStep = ({ file, mapping, setMapping, onBack, onNext }) => {
  const missing = ["address", "postcode"].filter((k) => mapping[k] == null);
  const sample = (i) => file.rows.map((r) => r[i]).find((v) => v) || "";
  return (
    <div className="space-y-4" data-testid="import-map-step">
      <p className="text-sm text-slate-600">{file.rows.length} rows found. Check which column holds each detail. Address and Postcode are required; set anything else to Ignore if it's not in your sheet.</p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {IMPORT_FIELDS.map(([k, label]) => (
          <div key={k}>
            <Label>{label}</Label>
            <Select value={mapping[k] == null ? "ignore" : String(mapping[k])} onValueChange={(v) => setMapping({ ...mapping, [k]: v === "ignore" ? null : Number(v) })}>
              <SelectTrigger className="mt-1.5" data-testid={`import-map-${k}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="ignore">Ignore</SelectItem>
                {file.headers.map((h, i) => <SelectItem key={`${h}-${i}`} value={String(i)}>{h}</SelectItem>)}
              </SelectContent>
            </Select>
            {mapping[k] != null && <p className="mt-1 truncate text-xs text-slate-500">e.g. {sample(mapping[k]) || "(empty)"}</p>}
          </div>
        ))}
      </div>
      {missing.length > 0 && <p className="rounded-md bg-rose-50 p-3 text-sm text-rose-700" data-testid="import-map-error">Pick the column for {missing.join(" and ")}.</p>}
      <div className="flex justify-between gap-2">
        <Button variant="outline" onClick={onBack} data-testid="import-map-back">Choose another file</Button>
        <Button onClick={onNext} disabled={missing.length > 0} className="bg-blue-700 hover:bg-blue-800" data-testid="import-map-next">Continue</Button>
      </div>
    </div>
  );
};
